import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UsuariosComponent } from './usuarios/usuarios.component';
import { CoordinadosComponent } from './coordinados/coordinados.component';
import { ProcesosComponent } from './procesos/procesos.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CoordinadosUsuariosComponent } from './coordinados-usuarios/coordinados-usuarios.component';

const routes: Routes = [
  {
  path: 'admin',
  children:
    [
      { path: '', component: DashboardComponent },
      { path: 'coordinados', component: CoordinadosComponent },
      { path: 'procesos', component: ProcesosComponent },
      { path: 'notificaciones', component: NotificacionesComponent },
      { path: 'usuarios', component: UsuariosComponent },
      { path: 'coordinados_usuarios', component: CoordinadosUsuariosComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
